import { Group, TextInput, type TextInputProps } from '@mantine/core';

export type NameFieldsProps = {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  firstNameError?: string;
  lastNameError?: string;
  disabled?: boolean;
  // Per-surface input styles, e.g. light labels on the navy /welcome card.
  inputStyles?: TextInputProps['styles'];
};

export function NameFields(props: Readonly<NameFieldsProps>) {
  return (
    <Group grow align="flex-start" gap={12}>
      <TextInput
        label="First name"
        autoComplete="given-name"
        value={props.firstName}
        onChange={(e) => props.onFirstNameChange(e.currentTarget.value)}
        error={props.firstNameError}
        disabled={props.disabled}
        styles={props.inputStyles}
      />
      <TextInput
        label="Last name"
        autoComplete="family-name"
        value={props.lastName}
        onChange={(e) => props.onLastNameChange(e.currentTarget.value)}
        error={props.lastNameError}
        disabled={props.disabled}
        styles={props.inputStyles}
      />
    </Group>
  );
}
